import ValidationRule from '../validation.rule.js';

export default class PasswordItemRule extends ValidationRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.container = document.getElementById('custom-password-rules');

        if (this.container === null) {
            console.warn(`No DOM Element with id "custom-password-rules" found for "${this.getRuleName()}" rule.`);
        }

        this.length = settings.minlength;

        if (typeof settings.minlength === "undefined") {
            console.warn(`No length found for "${this.getRuleName()}" rule.`);
        }

        // se branche sur le champ password
        this.password = this.loadTarget(`#${this.getFormID()} input[id="account-security-password"]`);

        // listenValidity appellera generateFeedbackElement
        this.listenValidity(this.password);
    }

    clearValidity() {
        //this.resetValidity(this.password.element)
    }

    // must be overrided in subclasses
    isValid() {
        return false;
    }

    refreshValidity() {
        const _isValid = this.isValid();
        if (_isValid) {
            this.getFeedbackElt().classList.remove('list-unchecked');
            this.getFeedbackElt().classList.remove('list-error');
            this.getFeedbackElt().classList.add('list-checked');
        } else {
            this.getFeedbackElt().classList.add('list-unchecked');
            this.getFeedbackElt().classList.remove('list-error');
            this.getFeedbackElt().classList.remove('list-checked');
        }


        return _isValid;
    }

    resetValidity(elt) {
        //elt.classList.remove('is-invalid');
        elt.setCustomValidity('');
    }


    listenValidity(target) {
        this.generateFeedback(target.element);

        target.element.addEventListener('input', () => {
            this.refreshValidity(target);
        });

        this.refreshValidity(target);
    }

    setCustomErrorMessage(inputElement, feedbackElement, message) {
        // @override
        // Do nothing in order to not shows custom error feedback.
        // That's not a complete sentencence with password rules but string like "at least 10 passowrd"
    }
    generateFeedback() {
        this.feedbackElt = document.createElement('li');
        this.feedbackElt.setAttribute('id', this.getRuleName());
        this.feedbackElt.className = "list-inline-item";
        this.feedbackElt.textContent = this.message;
        this.container.appendChild(this.feedbackElt);
    }

    getFeedbackElt() {
        return this.feedbackElt;
    }

    async check() {
        const isValid = this.isValid();
        const elt = this.password.element;
        if (!isValid){
            this.invalidate(elt);
            this.getFeedbackElt().classList.remove('list-unchecked');
            this.getFeedbackElt().classList.add('list-error');
        }
        else {
            this.resetValidity(elt);
        }

        return Promise.resolve(isValid);
    }
}
